// ** UseJWT import to get config
import useJwt from "@src/auth/jwt/useJwt";
import axios from "axios";
import themeConfig from "@configs/themeConfig";

const config = useJwt.jwtConfig;

// ** Handle User Login
export const handleLogin = (data) => {
  return (dispatch) => {
    dispatch({
      type: "LOGIN",
      data,
      config,
      [config.storageTokenKeyName]: data[config.storageTokenKeyName],
      [config.storageRefreshTokenKeyName]:
        data[config.storageRefreshTokenKeyName],
    });

    localStorage.setItem("userData", JSON.stringify(data));
    localStorage.setItem(config.storageTokenKeyName, data.accessToken);
    localStorage.setItem(
      config.storageRefreshTokenKeyName,
      JSON.stringify(data.refreshToken)
    );
  };
};

// ** Handle User Logout
export const handleLogout = (history, cookies, removeCookie) => {
  return (dispatch) => {
    dispatch({
      type: "LOGOUT",
      [config.storageTokenKeyName]: null,
      [config.storageRefreshTokenKeyName]: null,
    });
    // ** Remove user, accessToken & refreshToken from localStorage
    // const token = String(localStorage.getItem(config.storageTokenKeyName));
    const token = cookies["sso-session-token"]?.token;

    axios
      .post(`${themeConfig.app.api_url}/logout`, null, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {});
    localStorage.removeItem("userData");
    const cookieOptions = {
      path: "/",
      sameSite: "lax",
    };

    if (
      !window.location.hostname.includes("localhost") &&
      !window.location.hostname.includes("127.0.0.1")
    ) {
      cookieOptions.domain = ".alburoujsportsclub.com";
    }
    removeCookie("sso-session-token", cookieOptions);
    removeCookie("user-profile-larma", cookieOptions);
    localStorage.removeItem(config.storageTokenKeyName);
    localStorage.removeItem(config.storageRefreshTokenKeyName);
    localStorage.removeItem("skin");
    history.push("/login");
  };
};
